import React from 'react'
import styles from './DataTableHeaderCell.module.scss'

type Align = 'left' | 'center' | 'right'

interface DataTableHeaderCellProps {
  children?: React.ReactNode
  align?: Align
  width?: string
  className?: never
}

const alignMap: Record<Align, string> = {
  left: styles.left, center: styles.center, right: styles.right,
}

export const DataTableHeaderCell: React.FC<DataTableHeaderCellProps> = ({
  children, align = 'left', width,
}) => (
  <th style={width ? { width } : undefined} className={[styles.cell, alignMap[align]].join(' ')}>
    {children}
  </th>
)
